import { render, staticRenderFns } from "./goodsListByExperience.vue?vue&type=template&id=61b3accc&scoped=true"
import script from "./goodsListByExperience.vue?vue&type=script&lang=js"
export * from "./goodsListByExperience.vue?vue&type=script&lang=js"
import style0 from "./goodsListByExperience.vue?vue&type=style&index=0&id=61b3accc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b3accc",
  null
  
)

export default component.exports